export enum ECheckoutStatus {
    None,
    SelectingYears,
    YearsNotSelected,
    VINMissing,
    CheckoutTerms,
    CheckoutProcessing,
    CheckoutSuccess,
    CheckoutError
}

export enum EShipmentMethod {
    None,
    Pickup,
    Delivery,
    LTL,
    LTLWithLiftgate,
    Other
}

export interface IItemsSelectedYear {
    groupConcat: string;
    itemIds: number[];
    year: number;
    vin: string;
}

export interface ICheckoutOrder {
    cardcode: string;
    cartId: number;
    createdAt: string;
    createdByUserId: number;
    id: number;
    inSap: boolean | null;
    shippingAddressId: number;
    shippingMethodId: number;
    status: boolean;
    updatedAt: string;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/interfaces/checkout.ts